import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../../components/Header";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getApiEndpoint } from "../../utils/apiConfig";

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  document.title = t("login.0") || "Giriş";
  const headerTitle = t("login.1") || "Şəxsi kabinet";
  
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid = 
    formData.email.trim() !== "" && 
    validateEmail(formData.email) &&
    formData.password.trim() !== "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isFormValid) {
      if (!formData.email.trim()) {
        setError(t("login.emailRequired"));
        return;
      }
      if (!validateEmail(formData.email)) {
        setError(t("login.emailInvalid") || "Düzgün e-poçt ünvanı daxil edin");
        return;
      }
      if (!formData.password.trim()) {
        setError(t("login.passwordRequired"));
        return;
      }
      return;
    }
    
    setLoading(true);
    setError("");
    
    try {
      const userData = {
        email: formData.email.trim(),
        password: formData.password
      };

      const response = await axios.post(getApiEndpoint('auth/login'), userData);
      
      if (response.data && response.data.token) {
        // Store the token and user info
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        
        // Show success message
        setError("");
        
        // Check for redirection - same logic as OTP verification
        const redirectToAllMaterials = localStorage.getItem('redirectToAllMaterials');
        const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
        const pendingRepairId = localStorage.getItem('pendingRepairId');
        const returnToUrl = sessionStorage.getItem('returnToUrl');
        const tempRepairId = Object.keys(localStorage).find(key => key.startsWith('temp-'));
        
        console.log("Redirection options:", {
          redirectToAllMaterials,
          redirectAfterLogin,
          pendingRepairId,
          returnToUrl,
          tempRepairId
        });
        
        // Clear redirection flags
        localStorage.removeItem('redirectToAllMaterials');
        localStorage.removeItem('redirectAfterLogin');
        sessionStorage.removeItem('returnToUrl');
        
        if (redirectToAllMaterials === 'true' && pendingRepairId) {
          console.log("Redirecting to AllMaterials with pending repair ID:", pendingRepairId);
          localStorage.removeItem('pendingRepairId');
          navigate(`/allmaterials/${pendingRepairId}`);
        } else if (redirectAfterLogin) {
          console.log("Redirecting to redirectAfterLogin:", redirectAfterLogin);
          window.location.replace(redirectAfterLogin);
        } else if (returnToUrl) {
          console.log("Redirecting to returnToUrl:", returnToUrl);
          window.location.replace(returnToUrl);
        } else if (pendingRepairId) {
          console.log("Redirecting to pending repair ID:", pendingRepairId);
          localStorage.removeItem('pendingRepairId');
          navigate(`/allmaterials/${pendingRepairId}`);
        } else if (tempRepairId) {
          console.log("Redirecting to temp repair ID:", tempRepairId);
          const tempData = localStorage.getItem(tempRepairId);
          if (tempData) {
            localStorage.removeItem(tempRepairId);
            navigate(`/allmaterials/${tempRepairId}`);
          } else {
            navigate("/account");
          }
        } else {
          console.log("No specific redirection, going to account");
          navigate("/account");
        }
      } else {
        setError(t("login.loginError"));
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error.response && error.response.data && error.response.data.message) {
        if (error.response.data.message.includes('Geçersiz')) {
          setError(t("login.invalidCredentials"));
        } else {
          setError(error.response.data.message);
        }
      } else {
        setError(t("login.loginError"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-section mx-3">
      <Header 
        title={headerTitle} 
        showProfileIcon={false}
        showBackIcon={false}
      />
      <h2>{t("login.0")}</h2>
      
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className="top-section">
        <form onSubmit={handleSubmit} className="d-flex flex-column">
          <div className="email-section">
            <label className="mb-1">{t("login.email")}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder={t("login.enterEmail")}
              required
            />
          </div>
          
          <div className="password-section">
            <label className="mb-1">{t("login.password")}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder={t("login.enterPassword")}
              required
            />
          </div>

          <div className="button-section">
            <button 
              type="submit" 
              className="btn"
              disabled={!isFormValid || loading}
            >
              {loading ? t("signup.loading") : t("login.4")}
            </button>
          </div>
        </form>
        
        <div className="forgot-password-section text-center mt-3">
          <Link to="/forgot-password" className="forgot-password-link">
            {t("login.forgotPassword")}
          </Link>
        </div>
      </div>
      
      <div className="sign-up-section d-flex align-items-center justify-content-center mt-4">
        <h6>
          {t("login.5")} &nbsp;
          <Link to="/signup" className="signup">
            {t("login.6")}
          </Link>
        </h6>
      </div>
    </div>
  );
};

export default Login;